import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.iconbutton');
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-iconbutton',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.iconbutton/view.scss */
:host {
  display: inline-flex;
}

.lookit-icon-button {
  position: relative;
  display: inline-grid;
  width: var(--lookit-touch-icon);
  height: var(--lookit-touch-icon);
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid var(--lookit-border-medium);
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-surface);
  color: var(--lookit-color-text);
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.lookit-icon-button:active {
  transform: scale(0.97);
}

.lookit-icon-button:disabled {
  cursor: default;
  opacity: 0.45;
}

.lookit-icon-button__glyph {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
}

.lookit-icon-button__glyph svg {
  width: 21px;
  height: 21px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lookit-icon-button__badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border: 2px solid var(--lookit-color-surface);
  border-radius: var(--lookit-radius-pill);
  background: var(--lookit-color-price-drop);
  color: var(--lookit-color-on-accent);
  font-size: 10px;
  font-weight: var(--lookit-font-weight-black);
  line-height: 13px;
  text-align: center;
}

.lookit-icon-button.is-active {
  border-color: var(--lookit-color-text);
  background: var(--lookit-color-text);
  color: var(--lookit-color-surface);
}

.lookit-icon-button.is-rose {
  border-color: color-mix(in srgb, var(--lookit-color-accent) 60%, var(--lookit-color-text) 10%);
  background: var(--lookit-color-accent-soft);
  color: var(--lookit-color-accent-strong);
}

.lookit-icon-button.is-success {
  border-color: color-mix(in srgb, var(--lookit-color-price-drop) 55%, var(--lookit-color-text) 10%);
  background: var(--lookit-color-price-drop-soft);
  color: var(--lookit-color-price-drop);
}`],
})
export class ComponentLookitIconbuttonComponent {
    @Input() label: string = '버튼';
    @Input() icon: string = 'search';
    @Input() badge: string | number = '';
    @Input() active: boolean = false;
    @Input() disabled: boolean = false;
    @Input() tone: 'neutral' | 'rose' | 'success' = 'neutral';
    @Output() pressed = new EventEmitter<MouseEvent>();

    public onClick(event: MouseEvent) {
        if (this.disabled) return;
        this.pressed.emit(event);
    }
}

export default ComponentLookitIconbuttonComponent;